<template>
    <div class="statistic-data">
      <div class="bg-white p-4 mt-4 rounded-lg">
        <div class="d-lg-flex align-items-center justify-content-md-between">
          <h4 class="text-left mb-4">{{ title }}</h4>
          <!-- <button class="btn btn-sm btn-light" @click="handleCustom"><i class="fas fa-ellipsis-v"></i></button> -->
  
        </div>
        <div class="row align-items-lg-end justify-content-start flex-nowrap gap-3">
          <div :class="data.length >= 2 ? 'col' : 'col-lg-3'" v-for="item, index in data" :key="index">
            <div class="d-lg-flex d-flex gap-lg-3 gap-1 align-items-lg-end align-items-end justify-content-lg-start justify-content-lg-start mb-lg-0 mb-3">
              <div class="text-left">
                <h6 class="statistic-label text-secondary">{{ item.label }}</h6>
               <div class="pt-2">
                <CBadge :bg_color='item.color'>
                    <h5>{{  item.key }}</h5>
                 </CBadge>
               </div>
              </div>
              <div>
                <h4 :class="` text-${item.color} mb-1`"><strong>{{ item.value }}</strong></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import CBadge from './CBadge.vue'

  export default {
    name: 'StatisticRoom',
    components: {
      CBadge
    },
    props :{
      title: String,
      data: Array,
    },
    setup(props, {emit}){
      console.log(props)
  
      const handleCustom = (value) => {
        emit("show", value)
      }
      return {
        handleCustom
      }
  
    }
  }
  </script>
  
  <style>
  
  </style>